import { useContext } from "react";
import { WizardContext, WizardContextType } from "../providers/WizardProvider";

export type { WizardStep } from "../providers/WizardProvider";

function useWizard(
  _customer?: string,
  _economicProfile?: string
): WizardContextType {
  const context = useContext(WizardContext);

  if (context === null) {
    throw new Error("useWizard must be used within WizardContextProvider");
  }

  return context;
}

export default useWizard;
